import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginacaoEstoque } from '../page/estoque/paginacaoEstoque';
import { Estoque } from '../page/estoque/estoque';

@Injectable({
  providedIn: 'root'
})
export class EstoqueService {

  apiURL: string = environment.apiBaseUrl + 'estoque';

  constructor(private http: HttpClient) { }

  save(estoque: Estoque): Observable<Estoque> {
    return this.http.post<Estoque>(this.apiURL, estoque);
  }

  list(page: number, size: number): Observable<PaginacaoEstoque> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  update(estoque: Estoque): Observable<any> {
    return this.http.put<Estoque>(`${this.apiURL}/${estoque.id}`, estoque);
  }

  findClientById(id: number): Observable<Estoque> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findClientByIdActive(id: number): Observable<Estoque> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }
  
}